import { observer } from 'mobx-react-lite';
import React, { SyntheticEvent, useEffect } from 'react';
import { useStore } from '../../app/stores/store';
import { Card, Grid, Header, Tab, TabProps, Image } from 'semantic-ui-react';
import { UserActivity } from '../../app/models/profile';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';

const panes = [
  { menuItem: 'Future Events', pane: { key: 'future' } },
  { menuItem: 'Past Events', pane: { key: 'past' } },
  { menuItem: 'Hosting', pane: { key: 'hosting' } },
];

const ProfileActivities: React.FC = observer(() => {
  const { profileStore } = useStore();
  const { profile, loadUserActivities, loadingActivities, userActivities } =
    profileStore;

  useEffect(
    function loadUserActivitiesOnMount() {
      if (!profile) return;

      loadUserActivities(profile.username);
    },
    [loadUserActivities, profile],
  );

  const handleTabChange = async (event: SyntheticEvent, data: TabProps) => {
    if (!profile) return;
    event.preventDefault();
    const key = panes[data.activeIndex as number].pane.key;
    await loadUserActivities(profile.username, key);
  };

  return (
    <Tab.Pane loading={loadingActivities}>
      <Grid>
        <Grid.Column width={16}>
          <Header floated="left" icon="calendar" content="Activities" />
        </Grid.Column>
        <Grid.Column width={16}>
          <Tab
            panes={panes}
            menu={{ secondary: true, pointing: true }}
            onTabChange={(event, data) => handleTabChange(event, data)}
          />
          <br />
          <Card.Group itemsPerRow={4}>
            {userActivities.map((activity: UserActivity) => (
              <Card
                key={activity.id}
                as={Link}
                to={`/activities/${activity.id}`}
              >
                <Image
                  src={`/assets/categoryImages/${activity.category}.jpg`}
                  style={{ minHeight: '100', objectFit: 'cover' }}
                />
                <Card.Content>
                  <Card.Header textAlign="center">{activity.title}</Card.Header>
                  <Card.Meta>
                    <div>{format(new Date(activity.date), 'do LLL')}</div>
                    <div>{format(new Date(activity.date), 'h:mm a')}</div>
                  </Card.Meta>
                </Card.Content>
              </Card>
            ))}
          </Card.Group>
        </Grid.Column>
      </Grid>
    </Tab.Pane>
  );
});

export { ProfileActivities };
